import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"swal2-icon swal2-success swal2-icon-show\" style=\"display:flex;\"><span class=\"swal2-success-line-tip\"></span><span class=\"swal2-success-line-long\"></span><div class=\"swal2-success-ring\"></div><div class=\"swal2-success-fix\"></div></div>", 1)
const _hoisted_2 = {
  class: "swal2-title",
  id: "swal2-title",
  style: {"display":"block"}
}
const _hoisted_3 = {
  class: "swal2-html-container",
  id: "swal2-html-container",
  style: {"display":"block"}
}
const _hoisted_4 = { class: "swal2-html-container__heading" }
const _hoisted_5 = {
  key: 0,
  class: "row gx-8 gx-lg-0 product__accessories"
}
const _hoisted_6 = {
  class: "row g-5 g-md-4 product-listings product-scroll__container special-accessories",
  id: "special-accessories-product-list"
}

import { PropType } from "vue";
import dictionary from "@/i18n/dictionary.json";
import { ProductTile } from "@/models/ProductList";
import TressProductTile from "@/components/TressProductTile.vue";
import { CustomerType } from "@/enums/CustomerType";
import { DataLayerApi } from "@/services/Api";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressSpecialAccessoriesModalView',
  props: {
  specialAccessories: {
    type: Object as PropType<Array<ProductTile>>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



DataLayerApi.createViewItemListEvent(
  "special-accessories",
  props.specialAccessories.map((x) => x.sku)
);
const showAsB2b = window.customerType == CustomerType.Business;

return (_ctx: any,_cache: any) => {
  const _component_tress_scroll = _resolveComponent("tress-scroll")!
  const _component_tress_carousel_controls = _resolveComponent("tress-carousel-controls")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t(_unref(dictionary).modal.specialAccessories.title)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t(_unref(dictionary).modal.specialAccessories.text)), 1),
      (__props.specialAccessories)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_tress_scroll, { class: "product-scroll" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.specialAccessories, (tile) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col col-6 col-md-3 col-xl-3 product-listings__container",
                      key: tile.sku
                    }, [
                      _createVNode(TressProductTile, {
                        content: tile,
                        "show-as-b2b": showAsB2b,
                        small: ""
                      }, null, 8, ["content"])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_tress_carousel_controls, {
              "carousel-id": "special-accessories-product-list",
              class: "product-scroll__controls"
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})